import { Component } from '@theme/component';

/**
 * @extends {Component<{fields: (HTMLInputElement | HTMLTextAreaElement)[], prepare: HTMLButtonElement, result: HTMLElement, message: HTMLTextAreaElement, status: HTMLElement, lengthNotice: HTMLElement, whatsapp?: HTMLAnchorElement, email?: HTMLAnchorElement}>}
 */
class OhCustomBrief extends Component {
  requiredRefs = ['prepare', 'result', 'message', 'status', 'lengthNotice'];

  connectedCallback() {
    super.connectedCallback();
    this.initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.initialize();
  }

  initialize() {
    this.refs.prepare.disabled = false;
    const params = new URLSearchParams(window.location.search);
    const reference = params.get('product')?.trim();
    const productField = this.refs.fields?.find((field) => field.dataset.fieldKey === 'product');
    if (reference && productField && !productField.value) {
      productField.value = reference.slice(0, productField.maxLength);
    }
  }

  prepareMessage() {
    const values = (this.refs.fields || []).filter((field) => field.value.trim());
    if (!values.length) {
      this.refs.status.textContent = this.dataset.emptyMessage || '';
      this.refs.fields?.[0]?.focus();
      return;
    }
    this.refs.message.value = [
      this.dataset.greeting,
      ...values.map((field) => `${field.dataset.messageLabel}: ${field.value.trim()}`),
    ].filter(Boolean).join('\n\n');
    this.refs.result.hidden = false;
    this.updateLinks();
    this.refs.status.textContent = this.dataset.preparedMessage || '';
    this.refs.message.focus();
  }

  updateLinks() {
    const { message, whatsapp, email, lengthNotice } = this.refs;
    const body = message.value.trim();
    let tooLong = false;
    if (whatsapp) {
      try {
        const url = new URL(whatsapp.dataset.baseUrl || '', window.location.href);
        if (url.protocol === 'https:') {
          url.searchParams.set('text', body);
          const fits = url.href.length <= 7000;
          if (!fits) url.searchParams.delete('text');
          whatsapp.href = url.href;
          tooLong ||= !fits;
        }
      } catch {
        whatsapp.href = whatsapp.dataset.baseUrl || '';
      }
    }
    if (email) {
      const base = email.dataset.baseUrl || '';
      if (base.startsWith('mailto:')) {
        const url = new URL(base);
        url.searchParams.set('subject', this.dataset.subject || '');
        url.searchParams.set('body', body);
        const fits = url.href.length <= 1800;
        if (!fits) url.searchParams.delete('body');
        url.search = url.search.replace(/\+/g, '%20');
        email.href = url.href;
        tooLong ||= !fits;
      }
    }
    lengthNotice.hidden = !tooLong;
  }

  async copyMessage() {
    try {
      await navigator.clipboard.writeText(this.refs.message.value);
      if (this.isConnected) this.refs.status.textContent = this.dataset.copiedMessage || '';
    } catch {
      if (!this.isConnected) return;
      this.refs.message.focus();
      this.refs.message.select();
      this.refs.status.textContent = this.dataset.copyFallback || '';
    }
  }
}

if (!customElements.get('oh-custom-brief-component')) {
  customElements.define('oh-custom-brief-component', OhCustomBrief);
}
